import "./iconify_sheet.css";
import "./DataBySite.css";
import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Breadcrumbs,
  Link,
  Stack,
  Card,
  CardContent,
  Button,
} from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { useLocation, useNavigate } from "react-router-dom";
import electric from "../../images/power_system.png";
import inverter from "../../images/cabinet.png";
import solar from "../../images/solar.png";
import battery from "../../images/battery_animation.gif";
import load from "../../images/load.webp";
import mppt from "../../images/mppt.jpeg";
import rectifier from "../../images/rectifier.png";
import { callUnsetApi } from "../../utils/api.js"; // Import the global unset API function

const DataBySite = () => {
  const location = useLocation();
  const stateName = sessionStorage.getItem("selectedState");
  const siteId = sessionStorage.getItem("selectedSiteId");
  const [controllerDate, setControllerDate] = useState("");
  const [isOnline, setIsOnline] = useState(false);
  const [data, setData] = useState({});
  const [statusClass, setStatusClass] = useState("offline");
  const [dateTime, setDateTime] = useState(null);
  const [hupsdata, setHupsData] = useState(null);
  const [frameData, setFrameData] = useState(null);
  const [initialLoading, setInitialLoading] = useState(true);
  const navigate = useNavigate();
  useEffect(() => {
    const userData = sessionStorage.getItem("userData");
    if (!userData) {
      navigate("/");
    } else {
      sessionStorage.setItem("lastVisitedPage", "/get_data_by_site");
    }

    // Call the "set" API when the component mounts
    const callSetApi = async () => {
      try {
        const response = await fetch(
          `https://api.bharatnet.sunshineiotronics.com/api/v2/live_frame/set/${siteId}`,
          {
            method: "GET",
          }
        );
        const data = await response.json();
        // console.log("Set API response:", data);
      } catch (error) {
        console.error("Error calling set API:", error);
      }
    };

    callSetApi();

    return () => {
      callUnsetApi(siteId);
    };
  }, [navigate, siteId]);
  const breadcrumbs = [
    <Link key="1" sx={{ color: "black" }} href="/dashboard">
      Dashboard
    </Link>,
    <Link key="2" sx={{ color: "black" }} href={`/dashboard`}>
      {stateName}
    </Link>,
    <Link key="3" sx={{ color: "black" }} href={`/${stateName}/displaySite`}>
      Display Sites
    </Link>,
    <Typography key="4" sx={{ color: "text.primary" }}>
      Go Live
    </Typography>,
  ];

  const handleViewMore = (siteId) => {
    navigate("/view_more", {
      state: { stateName, siteId },
    });
  };
  // Helper function to update icon status
  const updateSpecificIconStatus = (
    elementId,
    condition,
    addClass,
    removeClass,
    text
  ) => {
    const element = document.getElementById(elementId);
    if (element) {
      if (condition) {
        element.classList.remove(removeClass);
        element.classList.add(addClass);
        element.innerText = text.connected;
      } else {
        element.classList.remove(addClass);
        element.classList.add(removeClass);
        element.innerText = text.disconnected;
      }
    } else {
      console.warn(`Element with ID ${elementId} not found`);
    }
  };
  // Helper function to update icon status
  const updateIconStatus = (elementId, condition, addClass, removeClass) => {
    const element = document.getElementById(elementId);
    if (condition) {
      element.classList.remove(removeClass);
      element.classList.add(addClass);
    } else {
      element.classList.remove(addClass);
      element.classList.add(removeClass);
    }
  };

  useEffect(() => {
    const fetchHupsData = async () => {
      const fetchUrlHups = `https://api.bharatnet.sunshineiotronics.com/api/v2/hups/${siteId}`;
      try {
        const response = await fetch(fetchUrlHups);
        const result = await response.json();
        setHupsData(result);
        updateSpecificIconStatus(
          "pdu_connected",
          parseInt(result.hups_connected_status, 10) === 1,
          "badge-success",
          "badge-danger",
          { connected: "Connected", disconnected: "Disconnected" }
        );
      } catch (error) {
        console.error("Error fetching hupsdata:", error);
      }
    };

    const fetchFrameData = async () => {
      const fetchUrlFrame = `https://api.bharatnet.sunshineiotronics.com/api/v2/regular_frame_by_site/${siteId}`;
      try {
        const response = await fetch(fetchUrlFrame);
        const responseData = await response.json();
          console.log("Door Alarm:", responseData.door_alarm);
          console.log("Water Logging Alarm:", responseData.water_logging_alarm);
        setFrameData(responseData);
        setControllerDate(responseData.controller_datetime);

        const currentDate = new Date();
        const siteDate = new Date(
          responseData.controller_datetime
            .split(" ")[0]
            .split("-")
            .reverse()
            .join("-") +
          " " +
          responseData.controller_datetime.split(" ")[1]
        );

        setDateTime(responseData.controller_datetime);
        // console.log(responseData.system_voltage);

        const diffSeconds = Math.floor((currentDate - siteDate) / 1000);
        // console.log(`Time difference in seconds: ${diffSeconds}`);

        if (diffSeconds <= 300) {
          setIsOnline(true);
          setStatusClass("online");
        } else {
          setIsOnline(false);
          setStatusClass("offline");
        }

        // Update icon statuses based on responseData
        updateIconStatus(
          "smoke_icon",
          responseData.smoke_alarm === 1,
          "cbi--smoke-detector-red",
          "cbi--smoke-detector"
        );
        updateIconStatus(
          "door_open_icon",
          responseData.door_alarm === 1,
          "door--open--icon",
          "door--close--icon"
        );
        updateIconStatus(
          "water_logging_icon",
          responseData.water_logging_alarm === 0,
          "water--logging--on",
          "water--logging--off"
        );
        updateIconStatus(
          "water_leakage_icon",
          responseData.water_leakage_alarm === 1,
          "water--leakage--on",
          "water--leakage--off"
        );
        updateIconStatus(
          "unauthorised_access_icon",
          responseData.unauthorised_access === 1,
          "shield--off--icon",
          "shield--on--icon"
        );
        updateIconStatus(
          "hct_icon",
          responseData.htc_alarm === 1,
          "temperature-high--active--icon",
          "temperature-high--inactive--icon"
        );
        updateIconStatus(
          "inside_temp_icon",
          responseData.tcan_fail_alarm === 1,
          "temperature--inside--icon--red",
          "temperature--inside--icon"
        );
        updateIconStatus(
          "outside_temp_icon",
          responseData.tamb_fail_alarm === 1,
          "temperature--outside--icon--red",
          "temperature--outside--icon"
        );
        updateIconStatus(
          "humidity_icon_1",
          responseData.humidity_fail === 1,
          "humidity--icon--red",
          "humidity--icon"
        );
        updateSpecificIconStatus(
          "ftu_connected",
          parseInt(responseData.ftu_connected, 10) === 1,
          "badge-success",
          "badge-danger",
          { connected: "Connected", disconnected: "Disconnected" }
        );

        // Handle fan statuses
        for (let i = 1; i <= 6; i++) {
          const fanElement = document.getElementById(`fan_run_0${i}`);
          const fanStatus = responseData[`fan0${i}_status`];
          if (fanStatus === 2) {
            fanElement.classList.remove(
              "fan--default--icon",
              "fan--on--icon",
              "fan--fail--off-icon"
            );
            fanElement.classList.add("fan--fail--off-icon");
          } else if (fanStatus === 1) {
            fanElement.classList.remove(
              "fan--default--icon",
              "fan--on--icon",
              "fan--fail--off-icon"
            );
            fanElement.classList.add("fan--on--icon");
          } else {
            fanElement.classList.remove(
              "fan--default--icon",
              "fan--on--icon",
              "fan--fail--off-icon"
            );
            fanElement.classList.add("fan--default--icon");
          }
        }
      } catch (error) {
        console.error("Error fetching frame data:", error);
      }
    };

    const fetchData = async () => {
      await fetchHupsData();
      await fetchFrameData();
    };

    const fetchInitialData = async () => {
      setInitialLoading(true);
      await fetchData();
      setInitialLoading(false);
    };

    // Fetch initial data
    fetchInitialData();

    // Set interval to fetch data every 3 seconds
    const intervalId = setInterval(fetchData, 3000);

    // Clear interval on component unmount
    return () => clearInterval(intervalId);
  }, [siteId, location]);

  if (initialLoading) {
    return <div>Loading...</div>;
  }

  const query_01 = hupsdata.query_01;
  const query_02 = hupsdata.query_02;
  const query_03 = hupsdata.query_03;
  const query_04 = hupsdata.query_04;
  const query_05 = hupsdata.query_05;
  const query_06 = hupsdata.query_06;

  function getBatteryPercentage(voltage) {
    const maxVoltage = 13.8;
    const minVoltage = 9;
    const criticalVoltage = 7;
    if (voltage >= maxVoltage) {
      return 100;
    } else if (voltage <= criticalVoltage) {
      return 0;
    } else if (voltage <= minVoltage) {
      return Math.round(
        ((voltage - criticalVoltage) / (minVoltage - criticalVoltage)) * 30
      );
    } else {
      return Math.round(
        ((voltage - minVoltage) / (maxVoltage - minVoltage)) * 70 + 30
      );
    }
  }

  return (
    <Box m="1rem 1.5rem">
      <div className="container-fluid page-body-wrapper">
        <div className="main-panel">
          <div className="content-wrapper">
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              style={{ marginBottom: "1rem" }}
            >
              <Stack spacing={2}>
                <Breadcrumbs
                  separator={<NavigateNextIcon fontSize="medium" />}
                  aria-label="breadcrumb"
                >
                  {breadcrumbs}
                </Breadcrumbs>
              </Stack>
              <Typography variant="body1" sx={{ color: "text.secondary" }}>
                <div className={`status-indicator ${statusClass}`}>
                  <div className="status-light"></div>
                  <span className="status-text">
                    {siteId} | {dateTime}
                  </span>
                </div>
              </Typography>
            </Box>

            <div className="measurements-container">
              {/* <Card className="my-1 mx-2" style={{ width: "30%", flexShrink: 0 }}>
              <CardContent>
                <h4>Measurements</h4>

                <table className="table table-bordered" style={{ width: "100%" }}>
                  <thead className="table-grey">
                    <tr>
                      <th style={{ textAlign: "left" }}>Parameter</th>
                      <th className="fs-6">Value</th>
                    </tr>
                  </thead>
                  <tbody>
                   
                      <tr>
                        <td className="compact-cell text-start">
                          <div style={{ display: "flex", justifyContent: "flex-start" }}>
                            <span
                              className="temperature--inside--icon"
                              id="inside_temp_icon"
                            ></span>
                          <span className="fs-6 fw-semibold mb-0 ms-4" style={{ marginLeft: "10px", marginTop: "5px" }}>
                            Inside Temperature
                          </span>
                          </div>
                        </td>
                     <td>
                        <span className="fs-6 fw-bold inside-temp mb-0 text-success">
                          {frameData.temperature_inside} °C
                        </span>
                        </td>
                        
                      
                    </tr>


                    <tr>
                      <td className="compact-cell">
                        <div style={{ display: "flex", justifyContent: "flex-start" }}>
                          <span
                            className="temperature--outside--icon"
                            id="outside_temp_icon"
                          ></span>
                          <span className="fs-6 fw-semibold mb-0 ms-3" style={{ marginLeft: "10px", marginTop: "5px" }}>Outside Temperature</span>
                          </div>
                          </td><td>
                    
                        <span className="fs-6 fw-bold outside-temp mb-0">
                          {frameData.temperature_outside} °C
                        </span>
                        </td>
                    </tr>

      
                    <tr>
                      <td className="compact-cell">
                        <div style={{ display: "flex", justifyContent: "flex-start" }}>
                          <span
                            id="humidity_icon_1"
                            className="humidity--icon"
                          ></span>
                          <span className="fs-6 fw-semibold mb-0 ms-3" id="humidity_icon" style={{ marginLeft: "10px", marginTop: "5px" }}>
                            Humidity
                          </span>
                          </div>
                      </td>
                      <td>
                        <span className="fs-6 fw-bold humidity mb-0">
                          {frameData.humidity} %
                        </span>
                        </td>
                    </tr>

                 
                    <tr>
                      <td className="compact-cell">
                        <div style={{ display: "flex", justifyContent: "flex-start" }}>
                          <span className="battery--icon"></span>
                          <span className="fs-6 fw-semibold mb-0 ms-3" style={{ marginLeft: "10px", marginTop: "5px" }}>Lock Battery</span>
                          </div>
                          </td>
                      <td>
                        <span className="fs-6 fw-bold outside-temp mb-0">
                          {getBatteryPercentage(frameData.system_voltage)}%
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </CardContent>
            </Card> */}
              {/* Alarms Overview Section */}
              <Card className="my-0 mx-0" style={{ width: "100%", flexShrink: 0, marginBottom: "0.5rem", border: "2px solid #997d3d", borderRadius: "12px" }}>
                <CardContent>
                  <h4>Measurements & Alarms / Signals  </h4>

                  {/* First div: Inside Temperature, Outside Temperature, Humidity, Lock Battery */}
                  <div className="d-flex justify-content-between p-1">
                    <div
                      className="d-flex flex-column align-items-center"
                      style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      {/* Inside Temperature */}
                      <div
                        className="text-center btn-wrapper p-2"
                        style={{
                          flex: 1,
                          borderRight: "1px solid #ddd",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          textAlign: "center",
                        }}
                      >
                        <span
                          className="temperature--inside--icon"
                          id="inside_temp_icon"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            marginBottom: "8px",
                          }}
                        ></span>
                        <span className="fs-2 fw-medium">Inside Temperature</span>
                        <span className="fs-2 fw-bold inside-temp" id="inside_temp"> {frameData.temperature_inside} °C</span>
                      </div>


                      {/* Outside Temperature */}
                      <div
                        className="text-center btn-wrapper p-2"
                        style={{
                          flex: 1,
                          borderRight: "1px solid #ddd",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          textAlign: "center",
                        }}
                      >
                        <span
                          className="temperature--outside--icon"
                          id="outside_temp_icon"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            marginBottom: "8px",
                          }}
                        ></span>
                        <span className="fs-2 fw-medium">Outside Temperature</span>
                        <span className="fs-2 fw-bold outside-temp" id="outside_temp"> {frameData.temperature_outside} °C</span>
                      </div>


                      {/* Humidity */}
                      <div
                        className="text-center btn-wrapper p-2"
                        style={{
                          flex: 1,
                          borderRight: "1px solid #ddd",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          textAlign: "center",
                        }}
                      >
                        <span
                          className="humidity--icon"
                          id="humidity_icon_1"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            marginBottom: "8px",
                          }}
                        ></span>
                        <span className="fs-2 fw-medium">Humidity</span>
                        <span className="fs-2 fw-bold humidity" id="humidity"> {frameData.humidity} %</span>
                      </div>

                      {/* Lock Battery */}
                      <div
                        className="text-center btn-wrapper p-2"
                        style={{
                          flex: 1,
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          textAlign: "center",
                        }}
                      >
                        <span
                          className="battery--icon"
                          id="battery_icon"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            marginBottom: "8px",
                          }}
                        ></span>
                        <span className="fs-2 fw-medium">Lock Battery</span>
                        <span className="fs-2 fw-bold battery" id="battery"> {getBatteryPercentage(frameData.system_voltage)} %</span>
                      </div>
                    </div>
                  </div>

                  {/* Second div: Other params (Fans, Smoke/Fire, Door Open, etc.) */}
                  <div className="d-flex justify-content-between p-3">
                    <div
                      className="d-flex flex-column align-items-center"
                      style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        marginTop: "1rem",
                      }}
                    >


                      {/* Smoke/Fire */}
                      <div
                        className="text-center btn-wrapper p-2"
                        style={{
                          flex: 1,
                          borderRight: "1px solid #ddd",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          textAlign: "center",
                        }}
                      >
                        <span
                          className="cbi--smoke-detector"
                          id="smoke_icon"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            marginBottom: "8px",
                          }}
                        ></span>
                        <p className="fs-2 fw-medium">Smoke/Fire</p>
                      </div>

                      {/* Door Open */}
                      <div
                        className="text-center btn-wrapper p-2"
                        style={{
                          flex: 1,
                          borderRight: "1px solid #ddd",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          textAlign: "center",
                        }}
                      >
                        <span
                          className="door--close--icon"
                          id="door_open_icon"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            marginBottom: "8px",
                          }}
                        ></span>
                        <p className="fs-2 fw-medium">Door Open</p>
                      </div>

                      {/* High-Cabinet Temperature */}
                      <div
                        className="text-center btn-wrapper p-2"
                        style={{
                          flex: 1,
                          borderRight: "1px solid #ddd",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          textAlign: "center",
                        }}
                      >
                        <span
                          className="temperature-high--inactive--icon"
                          id="hct_icon"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            marginBottom: "8px",
                          }}
                        ></span>
                        <p className="fs-2 fw-medium">High-Cabinet Temperature</p>
                      </div>

                      {/* Water Leakage */}
                      <div
                        className="text-center btn-wrapper p-2"
                        style={{
                          flex: 1,
                          borderRight: "1px solid #ddd",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          textAlign: "center",
                        }}
                      >
                        <span
                          className="water--leakage--off"
                          id="water_leakage_icon"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            marginBottom: "8px",
                          }}
                        ></span>
                        <p className="fs-2 fw-medium">Water Leakage</p>
                      </div>

                      {/* Water Logging */}
                      <div
                        className="text-center btn-wrapper p-2"
                        style={{
                          flex: 1,
                          borderRight: "1px solid #ddd",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          textAlign: "center",
                        }}
                      >
                        <span
                          className="water--logging--off"
                          id="water_logging_icon"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            marginBottom: "8px",
                          }}
                        ></span>
                        <p className="fs-2 fw-medium">Water Logging</p>
                      </div>

                      {/* Unauthorised Access */}
                      <div
                        className="text-center btn-wrapper p-1"
                        style={{
                          flex: 1,
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          textAlign: "center",
                          borderRight: "1px solid #ddd",
                        }}
                      >
                        <span
                          className="shield--on--icon"
                          id="unauthorised_access_icon"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            marginBottom: "8px",
                          }}
                        ></span>
                        <p className="fs-2 fw-medium">Unauthorised Access</p>
                      </div>

                      {/* Fan 01 */}
                      <div
                        className="text-center btn-wrapper p-1"
                        style={{ flex: 1, borderRight: "1px solid #ddd" }}
                      >
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                          <p
                            className="fs-2 fw-medium"
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              fontWeight: "400",
                            }}
                          >
                            Fan 01
                          </p>
                          <span
                            className="fan--default--icon"
                            id="fan_run_01"
                          ></span>
                          <p
                            className="fs-2 fw-bold fan_01_runtime"
                            id="frh1"
                            style={{ display: "flex", justifyContent: "center" }}
                          >
                            {frameData.fan_run_hour_01} hr
                          </p>
                        </div>
                      </div>

                      {/* Fan 02 */}
                      <div
                        className="text-center btn-wrapper p-2"
                        style={{ flex: 1, borderRight: "1px solid #ddd"}}
                      >
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>

                          <p
                            className="fs-2 fw-medium"
                            style={{ display: "flex", justifyContent: "center" }}
                          >
                            Fan 02
                          </p>
                          <span
                            className="fan--default--icon"
                            id="fan_run_02"
                          ></span>

                          <p
                            className="fs-2 fw-bold fan_02_runtime"
                            id="frh2"
                            style={{ display: "flex", justifyContent: "center" }}
                          >
                            {frameData.fan_run_hour_02} hr
                          </p>
                        </div>
                      </div>

                      {/* Fan 03 */}
                      <div
                        className="text-center btn-wrapper p-2"
                        style={{ flex: 1, borderRight: "1px solid #ddd" }}
                      >
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>

                          <p
                            className="fs-2 fw-medium"
                            style={{ display: "flex", justifyContent: "center" }}
                          >
                            Fan 03
                          </p>
                          <span
                            className="fan--default--icon"
                            id="fan_run_03"
                          ></span>

                          <p
                            className="fs-2 fw-bold fan_03_runtime"
                            id="frh3"
                            style={{ display: "flex", justifyContent: "center" }}
                          >
                            {frameData.fan_run_hour_03} hr
                          </p>
                        </div>
                      </div>

                      {/* Fan 04 */}
                      <div
                        className="text-center btn-wrapper p-2"
                        style={{ flex: 1, borderRight: "1px solid #ddd" }}
                      >
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>

                          <p
                            className="fs-2 fw-medium"
                            style={{ display: "flex", justifyContent: "center" }}
                          >
                            Fan 04
                          </p>
                          <span
                            className="fan--default--icon"
                            id="fan_run_04"
                          ></span>

                          <p
                            className="fs-2 fw-bold fan_04_runtime"
                            id="frh4"
                            style={{ display: "flex", justifyContent: "center" }}
                          >
                            {frameData.fan_run_hour_04} hr
                          </p>
                        </div>
                      </div>

                      {/* Fan 05 */}
                      <div
                        className="text-center btn-wrapper p-2"
                        style={{ flex: 1, borderRight: "1px solid #ddd" }}
                      >
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>

                          <p
                            className="fs-2 fw-medium"
                            style={{ display: "flex", justifyContent: "center" }}
                          >
                            Fan 05
                          </p>
                          <span
                            className="fan--default--icon"
                            id="fan_run_05"
                          ></span>

                          <p
                            className="fs-2 fw-bold fan_05_runtime"
                            id="frh5"
                            style={{ display: "flex", justifyContent: "center" }}
                          >
                            {frameData.fan_run_hour_05} hr
                          </p>
                        </div>
                      </div>

                      {/* Fan 06 */}
                      <div
                        className="text-center btn-wrapper p-2"
                        style={{ flex: 1 }}
                      >
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>

                          <p
                            className="fs-2 fw-medium"
                            style={{ display: "flex", justifyContent: "center" }}
                          >
                            Fan 06
                          </p>
                          <span
                            className="fan--default--icon"
                            id="fan_run_06"
                          ></span>

                          <p
                            className="fs-2 fw-bold fan_06_runtime"
                            id="frh6"
                            style={{ display: "flex", justifyContent: "center" }}
                          >
                            {frameData.fan_run_hour_06} hr
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>

            <div style={{ display: "flex", gap: "1rem", width: "100%" }}>
              <div style={{ flex: "1", width: "50%", marginBottom: "0.5rem" }}>
                <Card style={{ width: "100%", flexShrink: 0, marginBottom: "0.5rem", border: "2px solid #997d3d", borderRadius: "12px", height: "100%" }}>
                  <CardContent>
                    {/* Title */}
                    <div className="card-title-container">
                      <h4>Hybrid UPS</h4>
                    </div>
                    <br />

                    <div className="diagram-container">
                      <div className="vertical-group-start">
                        <div className="vertical-group">
                          <Card
                            sx={{
                              width: "13rem",
                              height: "6.5rem",
                              border: "2px solid #ccc",
                            }}
                          >
                            <CardContent>
                              <div className="block electric-tower" style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "10px" }}>
                                <img className="image-data" src={electric} />
                                <div className="fields">
                                  <div
                                    className="field"
                                    style={{ textAlign: "left" }}
                                  >
                                    Mains
                                  </div>
                                  <div className="field">Mains Fail: No</div>
                                  <div className="field">
                                    Mains Run Hrs:{" "}
                                    {hupsdata.ac_mains_run_hours} hrs
                                  </div>
                                </div>
                              </div>
                            </CardContent>
                          </Card>
                          <div className="horizontal-connection">
                            <div class="arrow1">
                              <span>&gt;</span>
                              <span>&gt;</span>
                              <span>&gt;</span>
                              <span>&gt;</span>
                            </div>
                            <Card
                              sx={{
                                width: "12rem",
                                height: "6.5rem",
                                border: "2px solid #ccc",
                              }}
                            >
                              <CardContent sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                                <div className="block rectifier" style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", gap: "10px" }}>
                                  <img
                                    src={rectifier}
                                    className="image-data"
                                    style={{
                                      width: "35px",
                                      height: "35px",
                                    }}
                                  />
                                  <div className="fields">
                                    <div
                                      className="field"
                                      style={{
                                        fontWeight: "normal",
                                        textAlign: "left",
                                      }}
                                    >
                                      Rectifier
                                    </div>
                                    <div
                                      className="field"
                                      style={{ whiteSpace: "nowrap", textAlign: "left" }}
                                    >
                                      O/P Current:{" "}
                                      {
                                        hupsdata.rectifier_output_current
                                      }
                                      A
                                    </div>
                                    <div
                                      className="field"
                                      style={{
                                        textAlign: "left",
                                      }}
                                    >
                                      Output Power:{" "}
                                      {hupsdata.rectifier_output_power}KW
                                    </div>
                                  </div>
                                </div>
                              </CardContent>
                            </Card>

                            <div className="horizontal-connection">
                              <div class="arrow1" style={{ marginTop: "5rem" }}>
                                <span>&gt;</span>
                                <span>&gt;</span>
                                <span>&gt;</span>
                                <span>&gt;</span>
                              </div>
                            </div>
                          </div>
                        </div>


                        <div className="vertical-connection">
                          <div className="arrow-down">
                            <span>&gt;</span>
                            <span>&gt;</span>
                          </div>
                        </div>
                        <div className="vertical-group">
                          <div className="horizontal-connection">
                            <Card
                              sx={{
                                width: "12rem",
                                height: "6.5rem",
                                marginLeft: "16.5rem",
                                border: "2px solid #ccc",

                              }}
                            >
                              <CardContent>
                                <div className="battery-section-1">
                                  <div className="block battery" style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "10px" }}>
                                    <img
                                      src={battery}
                                      className="image-data"
                                      style={{ width: "32.5px" }}
                                    />
                                    <div className="fields">
                                      <div
                                        className="field"
                                        style={{ textAlign: "left" }}
                                      >
                                        Battery
                                      </div>
                                      <div className="field" style={{ textAlign: "left" }}>
                                        Voltage: {hupsdata.battery_voltage}
                                        V
                                      </div>
                                      <div className="field" style={{ textAlign: "left" }}>
                                        Current:{" "}
                                        {hupsdata.battery_current.toFixed(
                                          1
                                        )}
                                        A
                                      </div>

                                    </div>
                                  </div>
                                </div>
                              </CardContent>
                            </Card>
                            <div className="horizontal-connection">
                              <div class="arrow1">
                                <span>&gt;</span>
                                <span>&gt;</span>
                                <span>&gt;</span>
                                <span>&gt;</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="vertical-connection">
                          <div className="arrow-up">
                            <span>&gt;</span>
                            <span>&gt;</span>
                          </div>
                        </div>

                        <div className="vertical-group">
                          <Card
                            sx={{
                              width: "13rem",
                              height: "6.5rem",
                              border: "2px solid #ccc",
                            }}
                          >
                            <CardContent>
                              <div className="block solar-panel" style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "10px" }}>
                                <img src={solar} className="image-data" />
                                <div className="fields">
                                  <div
                                    className="field"
                                    style={{ textAlign: "left" }}
                                  >
                                    Solar Panel
                                  </div>
                                  <div className="field" style={{ textAlign: "left" }}>
                                    Ultimate Capacity:{" "}
                                    {hupsdata.solar_ultimate_capacity}Wp
                                  </div>
                                  <div className="field" style={{ textAlign: "left" }}>
                                    Solar Current: {hupsdata.solar_current}
                                    A
                                  </div>
                                </div>
                              </div>
                            </CardContent>
                          </Card>

                          <div className="horizontal-connection">
                            <div class="arrow1">
                              <span>&gt;</span>
                              <span>&gt;</span>
                              <span>&gt;</span>
                              <span>&gt;</span>
                            </div>
                            <Card
                              sx={{
                                width: "12rem",
                                height: "6.5rem",
                                border: "2px solid #ccc",
                              }}
                            >
                              <CardContent sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                                <div className="block mppt" style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", gap: "10px" }}>
                                  <img src={mppt} className="image-data" />
                                  <div className="fields">
                                    <div
                                      className="field"
                                      style={{ textAlign: "left" }}
                                    >
                                      MPPT
                                    </div>
                                    <div className="field" style={{ textAlign: "left" }}>
                                      Output Voltage:{" "}
                                      {hupsdata.mppt1_output_voltage}V
                                    </div>
                                    <div className="field" style={{ textAlign: "left" }}>
                                      Output Current:{" "}
                                      {hupsdata.mppt1_output_current}A
                                    </div>
                                    <div className="field" style={{ textAlign: "left" }}>
                                      Output Power:{" "}
                                      {hupsdata.mppt1_output_power}W
                                    </div>
                                  </div>
                                </div>
                              </CardContent>
                            </Card>

                            <div className="horizontal-connection">
                              <div class="arrow1" style={{ marginBottom: "5rem" }}>
                                <span>&gt;</span>
                                <span>&gt;</span>
                                <span>&gt;</span>
                                <span>&gt;</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <br />

                      <div className="battery-section-imp">
                        <div className="merge-battery-inverter">

                          <Card
                            sx={{
                              width: "15rem",
                              height: "22.5rem",
                              marginTop: "1rem",
                              border: "2px solid #ccc",
                              borderRadius: "20px",
                            }}
                          >
                            <CardContent>
                              <div
                                className="battery-section-1"
                                style={{ marginTop: "7.5rem" }}
                              >
                                <div className="block battery">
                                  <img src={load} className="image-data" />
                                  <div className="fields">
                                    <div
                                      className="field"
                                      style={{ textAlign: "center" }}
                                    >
                                      Load
                                    </div>
                                    <div className="field">
                                      Load Current:{" "}
                                      {hupsdata.load_current}A
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </CardContent>
                          </Card>
                        </div>
                      </div>
                    </div>
                    <div className="button-div-view">
                      <Button
                        color="success"
                        onClick={handleViewMore}
                        sx={{
                          border: "1px solid #997d3d",
                          color: "#ffffff",
                          fontWeight: "bold",
                          width: "10rem",
                          backgroundColor: "#997d3d",
                          "&:hover": {
                            backgroundColor: "#7a6330",
                          },
                        }}
                      >
                        View More
                      </Button>
                    </div>
                  </CardContent>
                </Card>
              </div>
              <div style={{ flex: "1", width: "50%", marginBottom: "0.5rem" }}>
                <Card style={{ width: "100%", flexShrink: 0, marginBottom: "0.5rem", border: "2px solid #997d3d", borderRadius: "12px", height: "100%" }}>
                  <CardContent>
                    <h4>RS485</h4>
                    <div className="row my-3">
                      <div className="col-md-12">
                        <table className="table table-bordered">
                          <thead className="table-grey" >
                            <tr>
                              <th className="fs-6" style={{ backgroundColor: "#997d3d", color: "#ffffff" }}>ID</th>
                              <th className="fs-6" style={{ backgroundColor: "#997d3d", color: "#ffffff" }}>Device</th>
                              <th className="fs-6" style={{ backgroundColor: "#997d3d", color: "#ffffff" }}>Baud Rate</th>
                              <th className="fs-6" style={{ backgroundColor: "#997d3d", color: "#ffffff" }}>Successful Polls</th>
                              <th className="fs-6" style={{ backgroundColor: "#997d3d", color: "#ffffff" }}>Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {/* Device 01 */}
                            <tr>
                              <td>01</td>
                              <td>Fan and Lock Controller</td>
                              <td>9600</td>
                              <td>90%</td>
                              <td>
                                <p className="fs-6">
                                  <span
                                    className="badge-danger py-2 px-2"
                                    id="ftu_connected"
                                    style={{ color: "#ffffff", fontWeight: "bold" }}
                                  ></span>
                                </p>
                              </td>
                            </tr>
                            {/* Device 02 */}
                            <tr>
                              <td>01</td>
                              <td>Hybrid UPS</td>
                              <td>9600</td>
                              <td>90%</td>
                              <td>
                                <p className="fs-6">
                                  <span
                                    className="badge-danger py-2 px-2"
                                    id="pdu_connected"
                                    style={{ color: "#ffffff", fontWeight: "bold" }}
                                  ></span>
                                </p>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: "2rem",
                        width: "100%",
                        marginTop: "13rem",
                      }}
                    >
                      {/* Hardware Version */}
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "end",
                          flex: 1,
                          textAlign: "end",
                          flexDirection: "column",
                          padding: "1rem",
                          borderRadius: "10px",
                          boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                          minWidth: "15rem", // Ensure the box is wide enough
                        }}
                      >
                        <Typography
                          variant="subtitle1"
                          sx={{
                            whiteSpace: "nowrap",
                            color: "grey",
                          }}
                        >
                          {" "}
                          Software Checksum - 03727CCB | Hardware Version -{" "}
                          {frameData.gateway_hardware_version} | Software Version -{" "}
                          {frameData.gateway_software_version}
                        </Typography>
                      </Box>
                    </Box>
                  </CardContent>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Box>
  );
};

export default DataBySite;
